import React from 'react';
import { FeaturesSectionHoverEffectsShopify } from '../common/feature-section-hover-effects-shopify';
const ShopifyServies = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="text-center lg:col-span-8 lg:col-start-3 pb-50">
                        <p
                            className="text-primary mb-0 fs-lg fw-700"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            We Provide
                        </p>
                        <h2 data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Shopify Development Services
                        </h2>
                    </div>
                </div>
                <div className="row relative">         
                                    <div className="w-full">
                                       <FeaturesSectionHoverEffectsShopify />
                                    </div>         
                                </div>
                {/* <div className="row grid xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2">
                    <SubServices
                        path={'/img/technology/ic-shopify-store-design.svg'}
                        height={64}
                        width={64}
                        alt="shopify-store"
                        title="shopify-store"
                        serviceName="Shopify Store Design & Development"
                        serviceDescription="Moweb provides full-service Shopify design and development to understand your company's goals, target market, and specific needs. We create and design custom Shopify stores to capture the essence of the brand while also engaging the audience."
                    />
                    <SubServices
                        path={'/img/technology/ic-cutome-shopify-website.svg'}
                        height={64}
                        width={64}
                        alt="shopify-website"
                        title="shopify-website"
                        serviceName="Custom Shopify Website Development"
                        serviceDescription="As a full-service Shopify development company, we meet a wide range of e-commerce website needs with customized solutions. We plan our development around your e-commerce goals and deliver a successful e-commerce store."
                    />
                    <SubServices
                        path={'/img/technology/ic-app-integration.svg'}
                        height={64}
                        width={64}
                        alt="app-integration"
                        title="app-integration"
                        serviceName="Shopify App Integration & Configuration"
                        serviceDescription="Our Shopify programmers specialize in integrating and configuring your e-commerce store with various front-end and back-end systems using Shopify APIs. To meet the specific requirements of our users, we connect data, systems, services, and people."
                    />
                    <SubServices
                        path={'/img/technology/ic-shopify-theme.svg'}
                        height={64}
                        width={64}
                        alt="shopify-theme"
                        title="shopify-theme"
                        serviceName="Shopify Theme Development"
                        serviceDescription="Our dedicated Shopify developers have experience creating or customizing highly responsive themes and delivering striking UIs. Also, to design and develop mobile-ready themes that can improve user experiences, we adhere to Shopify standards."
                    />
                    <SubServices
                        path={'/img/technology/ic-shopify-plus-store.svg'}
                        height={64}
                        width={64}
                        alt="shopify-plus-store"
                        title="shopify-plus-store"
                        serviceName="Shopify Plus Development"
                        serviceDescription="Our Shopify Plus development services are created for businesses that require a more robust and scalable e-commerce platform. We offer custom solutions that cater to unique business needs, ensuring that Shopify Plus stores are visually appealing, user-friendly, and optimized for conversions."
                    />
                    <SubServices
                        path={'/img/technology/ic-shopify-maintence-upgrade.svg'}
                        height={64}
                        width={64}
                        alt="shopify-maintence"
                        title="shopify-maintence"
                        serviceName="Maintenance & Upgrade"
                        serviceDescription="We offer full Shopify maintenance and support services, including platform upgrades to the latest iteration, bug fixes, and performance optimization. With top-tier payment gateways, shopping carts, APIs, and third-party apps, we enhance your website's functionality."
                    />
                </div> */}
            </div>
        </div>
    );
};

export default ShopifyServies;
